// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"layout_pageContainer__3AYec","fixedWidth":"layout_fixedWidth__2o_Ms"};